// views.app.manage.applications.addApplication

export const ADD_APPLICATION = {
  title: 'Add Application'
};
